import {
  XRayProvider,
  useXRay,
  XRayToggle,
  Heading,
  Text,
  Button,
  Badge,
  Image,
} from '@bq/web-components';
import styles from './XRaySection.module.css';

function SampleComponents() {
  return (
    <div
      data-crd-id="r4.bq-xray-sample"
      data-crd-layer="r4"
      className={styles.sample}
    >
      <div className={styles.sampleCard}>
        <div
          data-crd-id="r3.bq-sample-card"
          data-crd-layer="r3"
          className={styles.card}
        >
          <Image
            src="/assets/images/logo-blue.png"
            alt="BlueQueue Logo"
            width={80}
            className={styles.cardImage}
          />
          <div className={styles.cardContent}>
            <Heading level={4} as={4}>
              Cognitive Recursive Design
            </Heading>
            <Text size="r2">
              Each UI component is built from lower layers — R1 tokens feed R2
              elements, which compose into R3 components.
            </Text>
            <div className={styles.cardActions}>
              <Button variant="primary" size="small">
                Explore
              </Button>
              <Badge variant="success">CRD</Badge>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function XRaySectionInner() {
  const { enabled, highlightedLayer } = useXRay();

  return (
    <section
      id="xray"
      data-crd-id="r4.bq-xray-section"
      data-crd-layer="r4"
      className={styles.section}
    >
      <div className={styles.intro}>
        <Badge variant="default">Feature #1</Badge>
        <Heading level={2} as={2} align="center">
          X-Ray Mode
        </Heading>
        <Text size="r1" align="center" color="n500">
          Toggle X-Ray to reveal the CRD layer boundaries inside every
          component. Each color represents a different layer in the hierarchy.
          Click a layer in the legend to spotlight it.
        </Text>
      </div>

      <div className={styles.controls}>
        <XRayToggle />
      </div>

      <div
        className={styles.viewport}
        data-xray-active={enabled ? 'true' : undefined}
        data-xray-highlight={
          enabled && highlightedLayer ? highlightedLayer : undefined
        }
      >
        <SampleComponents />
      </div>
    </section>
  );
}

export function XRaySection() {
  return (
    <XRayProvider>
      <XRaySectionInner />
    </XRayProvider>
  );
}
